'use client';

import { useLocale, useTranslations } from 'next-intl';
import { usePathname, useRouter } from '@/i18n/routing';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Globe } from 'lucide-react';
import { SUPPORTED_LANGUAGES } from '@/i18n/languages';

export default function LanguageSwitcher() {
    const t = useTranslations('Header');
    const locale = useLocale();
    const router = useRouter();
    const pathname = usePathname();

    const handleLanguageChange = (newLocale) => {
        router.replace(pathname, { locale: newLocale });
    };

    const currentLanguage = SUPPORTED_LANGUAGES.find(lang => lang.code === locale) || SUPPORTED_LANGUAGES[0];

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    className="flex items-center gap-2 text-gray-300 hover:text-amber-400 transition-colors text-sm"
                    aria-label={t('languageSwitcherAriaLabel', { language: currentLanguage.label })}
                >
                    <Globe className="w-4 h-4" />
                    <span className="hidden sm:inline-block">{currentLanguage.label}</span>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-neutral-800 border-neutral-700">
                {SUPPORTED_LANGUAGES.map((lang) => (
                    <DropdownMenuItem
                        key={lang.code}
                        className={`cursor-pointer text-sm ${locale === lang.code ? 'text-amber-400 font-medium' : 'text-gray-300 hover:text-white'
                            }`}
                        onClick={() => handleLanguageChange(lang.code)}
                    >
                        {lang.label}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
